import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '@components/@core/Icon';

const CheckIcon = ({ className, size = 20, checked = false, onClick = () => {} }) => (
    <Icon size={size} name={cx(className, checked ? 'fas fa-circle-check' : 'far fa-circle', 'mr-2')} active={checked} color={checked ? "#969faa" : "#d1d5db"} onClick={onClick} />
);

CheckIcon.propTypes = {
    className: PropTypes.string,
    size: PropTypes.number,
    checked: PropTypes.bool,
    onClick: PropTypes.func,
};

export default CheckIcon;
